import { render, staticRenderFns } from "./StoreCustomer.vue?vue&type=template&id=4e7dca5d&scoped=true"
import script from "./StoreCustomer.vue?vue&type=script&lang=js"
export * from "./StoreCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7dca5d",
  null
  
)

export default component.exports